import {UsersListHeader} from './components/header/UsersListHeader'
import {KTCard, KTCardBody} from '../../../../../template/_metronic/helpers'
import {UserTable} from './table/UserTable'
import {TitleCard} from '../../../../../helpers/elements/card/TitleCard'
import {useState} from 'react'
import {UserCreateModal} from './user-create-modal/UserCreateModal'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../../../redux/store'
import {useCleanSuccessMessageHook} from '../../../../../helpers/hooks/useCleanSuccessMessageHook'
import {ListViewProvider, useListView} from '../core/ListViewProvider'
import {UserEditModal} from './user-edit-modal/UserEditModal'
import {UserDeleteModal} from './user-delete-modal/UserDeleteModal'
import RoleBaseGuard from '../../../../../helpers/elements/RoleBaseGuard'
import CustomMessage from '../../../../../libs/_fri/components/CustomMessage'
import {cleanSuccessMessage} from '../../../../../redux/slices/messageSlice'

const UserList = () => {
  const [showCreateModal, setShowCreateModal] = useState(false)
  const successMessage = useSelector((state: RootState) => state.messageRedux)
  const cleanSuccessMessageHook = useCleanSuccessMessageHook()
  const dispatch = useDispatch()
  const {userIdForUpdate, userIdForDelete} = useListView()

  return (
    <>
      <CustomMessage
        title={successMessage.title}
        description={successMessage.description}
        messageType={successMessage.messageType}
        displayType={successMessage.displayType}
        close={() => {
          dispatch(cleanSuccessMessage())
        }}
      />
      <TitleCard title='Administración de usuarios' subtitle='Listado de usuarios'>
        <RoleBaseGuard permission='new_user'>
          <button
            className='btn btn-primary'
            onClick={() => {
              setShowCreateModal(true)
            }}
          >
            Crear usuario
          </button>
        </RoleBaseGuard>
      </TitleCard>
      <KTCard>
        <UsersListHeader />
        <KTCardBody className='border-0 pt-6'>
          <UserTable />
        </KTCardBody>
      </KTCard>
      {userIdForUpdate !== undefined && <UserEditModal />}
      {userIdForDelete !== undefined && <UserDeleteModal />}
      {showCreateModal && <UserCreateModal handleClose={() => setShowCreateModal(false)} />}
    </>
  )
}

const UserListWrapper = () => (
  <ListViewProvider>
    <UserList />
  </ListViewProvider>
)

export {UserListWrapper}
